var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_18647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67383 11.1641C8.67383 11.8102 9.19953 12.3359 9.8457 12.3359H11.2227C11.8688 12.3359 12.3945 11.8102 12.3945 11.1641V9.78711C12.3945 9.14094 11.8688 8.61523 11.2227 8.61523H9.8457C9.19953 8.61523 8.67383 9.14094 8.67383 9.78711V11.1641ZM9.8457 9.78711H11.2227L11.2234 11.164C11.2234 11.164 11.2232 11.1641 11.2227 11.1641H9.8457V9.78711Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8086 7.2373C12.1322 7.2373 12.3945 6.97497 12.3945 6.65137C12.3945 6.32776 12.1322 6.06543 11.8086 6.06543C11.485 6.06543 11.2227 6.32776 11.2227 6.65137C11.2227 6.97497 11.485 7.2373 11.8086 7.2373Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25977 7.2373C9.58337 7.2373 9.8457 6.97497 9.8457 6.65137C9.8457 6.32776 9.58337 6.06543 9.25977 6.06543C8.93616 6.06543 8.67383 6.32776 8.67383 6.65137C8.67383 6.97497 8.93616 7.2373 9.25977 7.2373Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 10.8125C15.2377 10.8125 15.5 10.5502 15.5 10.2266V4.01562C15.5 2.72328 14.4486 1.67188 13.1562 1.67188H12.3945V1.08594C12.3945 0.762324 12.1322 0.5 11.8086 0.5C11.485 0.5 11.2227 0.762324 11.2227 1.08594V1.67188H8.55664V1.08594C8.55664 0.762324 8.29432 0.5 7.9707 0.5C7.64709 0.5 7.38477 0.762324 7.38477 1.08594V1.67188H4.74805V1.08594C4.74805 0.762324 4.48572 0.5 4.16211 0.5C3.8385 0.5 3.57617 0.762324 3.57617 1.08594V1.67188H2.84375C1.55141 1.67188 0.5 2.72328 0.5 4.01562V13.1562C0.5 14.4486 1.55141 15.5 2.84375 15.5H13.1562C14.4486 15.5 15.5 14.4486 15.5 13.1562C15.5 12.8326 15.2377 12.5703 14.9141 12.5703C14.5904 12.5703 14.3281 12.8326 14.3281 13.1562C14.3281 13.8024 13.8024 14.3281 13.1562 14.3281H2.84375C2.19758 14.3281 1.67188 13.8024 1.67188 13.1562V4.01562C1.67188 3.36945 2.19758 2.84375 2.84375 2.84375H3.57617V3.42969C3.57617 3.7533 3.8385 4.01562 4.16211 4.01562C4.48572 4.01562 4.74805 3.7533 4.74805 3.42969V2.84375H7.38477V3.42969C7.38477 3.7533 7.64709 4.01562 7.9707 4.01562C8.29432 4.01562 8.55664 3.7533 8.55664 3.42969V2.84375H11.2227V3.42969C11.2227 3.7533 11.485 4.01562 11.8086 4.01562C12.1322 4.01562 12.3945 3.7533 12.3945 3.42969V2.84375H13.1562C13.8024 2.84375 14.3281 3.36945 14.3281 4.01562V10.2266C14.3281 10.5502 14.5904 10.8125 14.9141 10.8125Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16211 12.334C4.48571 12.334 4.74805 12.0717 4.74805 11.748C4.74805 11.4244 4.48571 11.1621 4.16211 11.1621C3.83851 11.1621 3.57617 11.4244 3.57617 11.748C3.57617 12.0717 3.83851 12.334 4.16211 12.334Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16211 7.2373C4.48571 7.2373 4.74805 6.97497 4.74805 6.65137C4.74805 6.32776 4.48571 6.06543 4.16211 6.06543C3.83851 6.06543 3.57617 6.32776 3.57617 6.65137C3.57617 6.97497 3.83851 7.2373 4.16211 7.2373Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16211 9.78711C4.48571 9.78711 4.74805 9.52478 4.74805 9.20117C4.74805 8.87757 4.48571 8.61523 4.16211 8.61523C3.83851 8.61523 3.57617 8.87757 3.57617 9.20117C3.57617 9.52478 3.83851 9.78711 4.16211 9.78711Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 9.78711C7.03454 9.78711 7.29688 9.52478 7.29688 9.20117C7.29688 8.87757 7.03454 8.61523 6.71094 8.61523C6.38733 8.61523 6.125 8.87757 6.125 9.20117C6.125 9.52478 6.38733 9.78711 6.71094 9.78711Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 7.2373C7.03454 7.2373 7.29688 6.97497 7.29688 6.65137C7.29688 6.32776 7.03454 6.06543 6.71094 6.06543C6.38733 6.06543 6.125 6.32776 6.125 6.65137C6.125 6.97497 6.38733 7.2373 6.71094 7.2373Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 12.334C7.03454 12.334 7.29688 12.0717 7.29688 11.748C7.29688 11.4244 7.03454 11.1621 6.71094 11.1621C6.38733 11.1621 6.125 11.4244 6.125 11.748C6.125 12.0717 6.38733 12.334 6.71094 12.334Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_18647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.f2037fa31f3664047c0e88b0988b73fa.svg";
export { ForwardRef as ReactComponent };